import styled from "styled-components";

export const DonationBackground = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  backdrop-filter: blur(3px);
  background-color: rgba(73, 73, 73, 0.3);
`;

export const DonationContainer = styled.div`
  position: fixed;
  top: 50%;
  left: 50%;
  width: 90%;
  max-width: 700px;
  transform: translate(-50%, -50%);
  background: white;
  border-radius: 15px;
  padding: 30px 40px;
  text-align: center;
`;

export const DonationCloseIcon = styled.i`
  position: absolute;
  top: 20px;
  right: 30px;
  font-size: 24px;
  color: #888;
  cursor: pointer;
`;

export const DonationHeader = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
`;

export const DonationTitle = styled.h2`
  font-size: 1.8rem;
  color: #000;
`;

export const AmountOptions = styled.div`
  display: flex;
  justify-content: center;
  gap: 2rem;
  flex-wrap: wrap;

  label {
    display: flex;
    align-items: center;
    gap: 0.5rem;
    font-size: 1rem;
  }

  input[type="radio"] {
    cursor: pointer;
  }

  input[type="radio"]:checked + label {
    color: #ff1493;
  }

  div {
    display: flex;
    gap: 0.5rem;
    justify-content: center;
  }
`;

export const AmountInput = styled.input`
  padding: 0.3rem 0.6rem;
  border: 1px solid #ccc;
  border-radius: 5px;
  width: 50px;
`;

export const BadgeOptions = styled.div`
  display: flex;
  justify-content: center;
  gap: 1.5rem;
`;

export const Badge = styled.div<{ $active: boolean }>`
  display: flex;
  width: 65px;
  flex-direction: column;
  align-items: center;
  cursor: pointer;
  padding: 10px;
  border-radius: 10px;
  background-color: ${({ $active }) => ($active ? "#ffe8d1" : "transparent")};

  .medal {
    width: 40px;
    height: 40px;
    border-radius: 50%;
    margin-bottom: 5px;
  }

  .bronze {
    background-color: #cd7f32;
  }

  .silver {
    background-color: #c0c0c0;
  }

  .gold {
    background-color: #ffd700;
  }
`;

export const BadgeLabel = styled.span`
  font-size: 0.9rem;
  color: #333;
`;

export const DonateButton = styled.button`
  margin-top: 2rem;
  width: 200px;
  padding: 0.75rem 1rem;
  font-size: 1rem;
  color: #fff;
  border: none;
  border-radius: 8px;
  background: #fe2f67;
  cursor: pointer;
  &:hover {
    background: #e8245a;
  }
`;
